import { action, observable, makeObservable } from 'mobx'
import { getURL, URL_TYPES } from '@voicekey/api/http'
import { SESSION_API } from '@voicekey/api/session/session'
import dynamicMessages from 'locales/dynamicMessages'

const url = getURL(URL_TYPES.SESSION)

export class SessionStore {
  constructor (rootStore) {
    makeObservable(this, {
      _sessionId: observable,
      _username: observable,
      resetSession: action,
      checkSessionId: action,
      deleteSession: action,
      startSession: action
    })

    this.rootStore = rootStore
  }

  _sessionId = ''

  get sessionId () {
    return this._sessionId
  }

  set sessionId (sessionId) {
    this._sessionId = sessionId
  }

  _username = ''

  get username () {
    return this._username
  }

  set username (value) {
    this._username = value
  }

  resetSession () {
    const externalLoginPagePath = window.appSettings && window.appSettings.externalLoginPagePath
    if (externalLoginPagePath) {
      window.location.replace(externalLoginPagePath)
    } else {
      this.sessionId = ''
      this.username = ''
      this.rootStore.domainStore.domainId = null
    }
    sessionStorage.removeItem('sessionId')
    sessionStorage.removeItem('domainId')
    sessionStorage.removeItem('username')
  }

  async checkSessionId (sessionId = this.sessionId) {
    try {
      const response = await SESSION_API.getSession(url, sessionId)
      if (!response.data.is_active) this.resetSession()
      return response.data.is_active
    } catch (e) {
      this.resetSession()
    }
  }

  async deleteSession () {
    try {
      await SESSION_API.deleteSession(url, this.sessionId)
    } finally { this.resetSession() }
  }

  async startSession (user, throwError = false) {
    try {
      const response = await SESSION_API.postSession(url, user)
      this.sessionId = response.data.session_id
      this.rootStore.domainStore.domainId = user.domain_id
      this.username = user.username
      sessionStorage.setItem('sessionId', response.data.session_id)
      sessionStorage.setItem('domainId', user.domain_id)
      sessionStorage.setItem('username', user.username)
    } catch (e) {
      this.rootStore.messagesStore.setMessage({
        ...dynamicMessages.authorization_fail,
        info: e
      })
      if (throwError) throw new Error()
    }
  }
}
